import { Navigate } from 'react-router-dom';

/**
 * Maps legacy/old CMS URLs to current routes.
 * These are URLs Google still has indexed from a previous site version.
 * Using Navigate with replace sends a proper client-side redirect.
 */

// Redirect patterns: [old path, new path]
export const LEGACY_REDIRECTS: [string, string][] = [
  // Old impressum paths
  ['/contact/impressum', '/impressum'],
  ['/checkout/impressum', '/impressum'],
  ['/people/impressum', '/impressum'],
  ['/retail/impressum', '/impressum'],
  
  // Old datenschutz paths (without umlaut, nested paths)
  ['/datenschutzerklarung', '/datenschutz'],
  ['/agb/datenschutzerklarung', '/datenschutz'],
  
  // Old section paths
  ['/people', '/about'],
  ['/retail', '/'],
  ['/contact', '/impressum'],
  ['/checkout', '/'],
  
  // Old portfolio paths
  ['/portfolio-category/content-creation', '/aktivierung'],
  ['/portfolio-category/event-construction', '/eventbau'],
  ['/portfolio-category/promotion', '/aktivierung'],
  ['/portfolio-category/brand-activation', '/aktivierung'],
];

export const LegacyRedirect = ({ to }: { to: string }) => (
  <Navigate to={to} replace />
);
